"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { forwardRef } from "react";
import { useId } from "./util/useId.js";
const SvgTruckFill = forwardRef((_a, ref) => {
    var { title, titleId: _titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    let titleId = useId();
    titleId = title ? _titleId ? _titleId : "title-" + titleId : undefined;
    return React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: false, role: "img", ref: ref, "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3.361 4.25c-.614 0-1.111.56-1.111 1.25v11c0 .69.497 1.25 1.111 1.25H3.5c.138 0 .25-.112.259-.25a3.5 3.5 0 0 1 6.982 0c.01.138.12.25.259.25h2.5c.138 0 .25-.112.259-.25.038-.541.2-1.048.456-1.494a.26.26 0 0 0 .035-.13V5.5c0-.69-.498-1.25-1.111-1.25zM21.75 16.5c0 .498-.291.928-.713 1.129-.142.068-.288-.05-.302-.207a3.5 3.5 0 0 0-4.619-2.984c-.174.06-.366-.063-.366-.247V7.5a.25.25 0 0 1 .25-.25h2.662c.51 0 .97.311 1.16.786l1.91 4.775a.3.3 0 0 1 .018.093zm-7 1.25a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m-7.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5", clipRule: "evenodd" }));
});
export default SvgTruckFill;
//# sourceMappingURL=TruckFill.js.map